module.exports = __webpack_public_path__ + "static/media/finacing-green.0f1cc688.svg";